export function customerFacingEntityName(value: unknown, validationRecord = false): string {
  void validationRecord;
  return String(value ?? '').trim();
}

export function isSampleEntityName(value: unknown): boolean {
  return /^\s*sample\b/i.test(String(value ?? ''));
}
